// _StampUtils.js

import Cookies from 'js-cookie';

const STAMPCARD_COOKIE_NAME = "stampcardStats";

const StampUtils =
{
	getStampStats: () =>
	{
		try
		{
			const stats = Cookies.get(STAMPCARD_COOKIE_NAME);
			return stats ? JSON.parse(stats) : {
				stamps: {},
				lastOpened: null,
				hasNewStamp: false
			};
		}
		catch (e)
		{
			console.error('Error parsing stamp stats:', e);
			return {
				stamps: {},
				lastOpened: null,
				hasNewStamp: false
			};
		}
	},

	saveStampStats: (stats) =>
	{
		Cookies.set(STAMPCARD_COOKIE_NAME, JSON.stringify(stats), { expires: 365 });
	},

	gainStamp: (buildingId) =>
	{
		const stats = StampUtils.getStampStats();

		// Only add if not already collected
		if (!stats.stamps[buildingId])
		{
			stats.stamps[buildingId] = {
				dateCollected: new Date().toISOString()
			};
			stats.hasNewStamp = true;
			StampUtils.saveStampStats(stats);
			return true;
		}
		return false;
	},

	markStampsViewed: () =>
	{
		const stats = StampUtils.getStampStats();
		stats.lastOpened = new Date().toISOString();
		stats.hasNewStamp = false;
		StampUtils.saveStampStats(stats);
	},

	hasNewStamps: () =>
	{
		const stats = StampUtils.getStampStats();
		return stats.hasNewStamp;
	}
};

export default StampUtils;